<main class="mat-body">
    <div class="bg-white">
        <div class="container">
            <div class="row justify-content-center text-center">
                <div class="col-8 mt-5">
                    <thr-radio-button class="justify-content-center" [size]="160" [checked]="true">
                        <i class="icon-natural"></i>
                    </thr-radio-button>
                    <label class="mat-headline text-blue" [innerHTML]="'contract.nature.natural'|translate"></label>
                </div>
            </div>
        </div>
    </div>
    <div class="container">
        <div class="row justify-content-center text-center">
            <div class="col-12 col-md-10 mt-5">
                <h1 class="mat-display-2 text-blue text-center font-weight-bold">{{ 'contract.natural.type'|translate }}</h1>
            </div>
        </div>
        <div class="row justify-content-center text-center my-4">
            <div class="col-5 col-md-4">
                <button type="button" class="full-width mat-elevation-z0" mat-raised-button color="white" (click)="onClick(true)">
                    {{ 'general.yes'|translate }}
                </button>
            </div>
            <div class="col-5 col-md-4 offset-md-2">
                <button type="button" class="full-width mat-elevation-z0" mat-raised-button color="white" (click)="onClick(false)">
                    {{ 'general.no'|translate }}
                </button>
            </div>
        </div>
    </div>
</main>
